// extracted by mini-css-extract-plugin
module.exports = {"avatars":"cd01fbf7b5--avatars--_MZr4","primary":"cd01fbf7b5--primary--Iw0n2","secondary":"cd01fbf7b5--secondary--LCZvi"};